// @flow
import { windowWrapper } from '@clubmed/utils';

import logger from 'Logger';
import * as pleUtils from 'Utils/ple-utils';

export function createAuthenticationMiddleware() {
  return () => (next: *) => (action: Action<*> | OptimisticAction<*, *>) => {
    try {
      // Works only on rejected optimistic actions, with a redirect_uri in payload's meta
      // $FlowFixMe
      const redirectUri = action.meta?.redirect_uri;
      if (!!redirectUri && pleUtils.hasAuthResponseError(action.payload)) {
        windowWrapper.setLocation(redirectUri);
      }
    } catch (e) {
      logger.warn(e);
    }
    return next(action);
  };
}
